module.exports = __webpack_public_path__ + "static/media/Arnaud.f57c8f11.jpg";